import SearchableTagsField from "./SearchableTagsField"

export default SearchableTagsField
